import { actionCreators, actionTypes, reducers, selectors } from './ducks';
import * as sagas from './sagas';

export const notifications = {
    reducers,
    selectors,
    actionTypes,
    actionCreators,
    sagas,
};
